import React, { useEffect, useState } from 'react';
import { leavesAPI } from '../../services/api';
import { parseApiError } from '../../utils/errors';

const STATUS_COLOR = { pending: 'orange', approved: 'green', rejected: 'red' };

export default function Leaves() {
  const [leaves, setLeaves] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ start_date: '', end_date: '', reason: '' });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = () => leavesAPI.list().then(({ data }) => setLeaves(data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const set = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await leavesAPI.create(form);
      setShowForm(false);
      setForm({ start_date: '', end_date: '', reason: '' });
      load();
    } catch (err) { setError(parseApiError(err, 'Failed to submit leave')); }
  };

  return (
    <div className="page">
      <div className="page-header">
        <h2>Leave Requests</h2>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>{showForm ? 'Cancel' : '+ Request Leave'}</button>
      </div>

      {showForm && (
        <div className="form-card mb-6">
          {error && <div className="alert alert-error">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Start Date *</label>
                <input type="date" required value={form.start_date} onChange={set('start_date')} />
              </div>
              <div className="form-group">
                <label>End Date *</label>
                <input type="date" required value={form.end_date} onChange={set('end_date')} />
              </div>
            </div>
            <div className="form-group">
              <label>Reason</label>
              <textarea rows={3} value={form.reason} onChange={set('reason')} />
            </div>
            <div className="form-actions">
              <button type="button" className="btn btn-ghost" onClick={() => setShowForm(false)}>Cancel</button>
              <button type="submit" className="btn btn-primary">Submit Request</button>
            </div>
          </form>
        </div>
      )}

      {loading ? <div className="page-loading">Loading...</div> : leaves.length === 0 ? (
        <div className="empty-state">No leave requests yet.</div>
      ) : (
        <div className="card">
          <table className="data-table">
            <thead><tr><th>From</th><th>To</th><th>Days</th><th>Reason</th><th>Status</th><th>HR Response</th></tr></thead>
            <tbody>
              {leaves.map((l) => {
                const days = Math.ceil((new Date(l.end_date) - new Date(l.start_date)) / 86400000) + 1;
                return (
                  <tr key={l.id}>
                    <td>{l.start_date}</td>
                    <td>{l.end_date}</td>
                    <td>{days}</td>
                    <td>{l.reason || '—'}</td>
                    <td><span className={`badge badge-${STATUS_COLOR[l.status]}`}>{l.status}</span></td>
                    <td>{l.hr_response || <span className="text-muted">Pending</span>}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
